import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { studentParentsCrudStateConfig } from "../../consts";

const studentParentsMetaReducer = makeCrudStateReducer(
  studentParentsCrudStateConfig
);
export default studentParentsMetaReducer;
